<a routerLink="/">
  <figure class="logo">
    <img [src]="logo" alt="Logo" />
  </figure>
</a> 
